import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "size-10 rounded user-avatar"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["textContent"]

import {NavigationUser} from "../../../../../Domain/Navigation/NavigationUser";
import Icon from "../../../Icon/Icon.vue";

interface Props {
  user: NavigationUser|null;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'UserAvatar',
  props: {
    user: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (props.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (props.user.avatarUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "rounded size-10 object-cover",
              src: props.user.avatarUrl
            }, null, 8 /* PROPS */, _hoisted_2))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              textContent: _toDisplayString(props.user.avatarInitials),
              class: "text-center leading-10"
            }, null, 8 /* PROPS */, _hoisted_3))
      ]))
    : (_openBlock(), _createBlock(Icon, {
        key: 1,
        name: "navigationGuestAvatar",
        class: "cursor-pointer py-3 px-3 rounded hover:accent"
      }))
}
}

})